<template>
  <path
    d="M12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM12 17.0002C11.45 17.0002 11 16.5502 11 16.0002V12.0002C11 11.4502 11.45 11.0002 12 11.0002C12.55 11.0002 13 11.4502 13 12.0002V16.0002C13 16.5502 12.55 17.0002 12 17.0002ZM13 9.00018H11V7.00018H13V9.00018Z"
  />
</template>
